import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: {},
    rawMaterials: [],
    groupedData: [],
    summary: {
      totalItems: 0,
      totalQuantity: 0,
      totalValue: 0,
      lowStockItems: 0,
    },
  },
  loading: false,
  error: null,
};

const rawMaterialReportSlice = createSlice({
  name: "RawMaterialReport",
  initialState,
  reducers: {
    RawMaterialReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    RawMaterialReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { business, rawMaterials, groupedData, summary }
    },
    RawMaterialReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  RawMaterialReportRequest,
  RawMaterialReportSuccess,
  RawMaterialReportFailure,
} = rawMaterialReportSlice.actions;

export default rawMaterialReportSlice.reducer;
